import React from "react";
import { connect } from "react-redux";
import Person from "./Person";
import { TimelineLite, TweenLite, Power2, Circ } from "gsap";
import "gsap/src/uncompressed/plugins/ScrollToPlugin";

import ScrollArrow from "../scrollarrow/ScrollArrow";

class OfficePage extends React.Component {
  constructor() {
    super();

    this.state = {
      open: false,
      showScrollArrow: false,
      screenHeight: window.innerHeight,
      scrollToInterval: null,
    };

    this.openItem = this.openItem.bind(this);
    this.animateOpening = this.animateOpening.bind(this);
    this.getPosition = this.getPosition.bind(this);
    this.scrollToThis = this.scrollToThis.bind(this);
  }

  getPosition() {
    //console.log(this.refs.container.getBoundingClientRect(),window.pageYOffset);
  }
  openItem() {
    this.setState({ open: true });
  }

  animateOpening(clickedThumb) {
    let thisContainer = this.refs.container; //document.querySelector('#workItemContainer');
    let featureImage = thisContainer.querySelector(".feature-image");
    let peopleList = thisContainer.querySelector(".people-list");

    //console.log("Animate Office",featureImage,clickedThumb );

    //console.log(TweenLite);
    let open_tl = new TimelineLite();

    //let thumbPosition = clickedThumb.getBoundingClientRect();
    let thisContainerPostion = thisContainer.getBoundingClientRect();

    /*
      let yPosition = thumbPosition.y //+ clickedThumb.parent.getBoundingClientRect().y
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let thumbPageYpos = thumbPosition.y//+scrollTop
      let thisPageYpos = thisContainerPostion.y+scrollTop
      let animationStartYPos = thumbPageYpos //- thisPageYpos

      */
    //let yPosition = thumbPosition.y //+ clickedThumb.parent.getBoundingClientRect().y
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //let thumbPageYpos = thumbPosition.y//+scrollTop
    let thisPageYpos = thisContainerPostion.top + scrollTop;
    //let animationStartYPos = thumbPageYpos //- thisPageYpos

    //console.log('thumbPosition',thumbPosition);
    //console.log('clickedThumb top', clickedThumb.offsetParent.offsetTop,featureImage.offsetParent.offsetTop);
    ///console.log('thumbPageYpos',thumbPageYpos);
    //console.log('thisPageYpos',thisPageYpos);

    //open_tl.to('#workItemContainer',1,{minHeight:'100vh'})

    let background = this.refs.container.querySelector(".background");

    /// Fade in  the content at the top of the page

    let logo = this.refs.container.querySelector(".description .logo");
    let line = this.refs.container.querySelector(".description .line");
    let postal = this.refs.container.querySelector(".description .postal");
    let telephone = this.refs.container.querySelector(
      ".description .telephone"
    );
    let copy = this.refs.container.querySelector(".description .copy");

    //console.log('background',background);

    //console.log('thisPageYpos',thisPageYpos);

    open_tl.add(() => {
      document.querySelector("body").classList.add("force-hide-header");
      document
        .querySelector("body")
        .classList.add("disable-pointer-events-and-scroll");
      // Calculate position again
      // set the position again.. just in case there seem to be some inconsitent behaviour..
      let scrollToInterval = setInterval(this.scrollToThis, 40);
      this.setState({ scrollToInterval });

      document.querySelector("#transitonHolder").classList.add("show");
      document.querySelector("#transitonHolder").classList.add("no-blue-bg");
      document
        .querySelector("#transitonHolder")
        .classList.add("no-transitions");
    });

    open_tl.fromTo(
      "#work-office-fade-bg",
      0.5,
      { alpha: 0 },
      { alpha: 1 },
      "-=0"
    );
    open_tl.from(background, 0.5, { alpha: 0 }, "-=.5");
    open_tl.set("#work-office-fade-bg", { alpha: 0 });
    open_tl.add(() => {
      document.querySelector("#transitonHolder").classList.remove("show");
      document.querySelector("#transitonHolder").classList.remove("no-blue-bg");
    });

    open_tl.add(() => {
      // Calculate position again
      // set the position again.. just in case there seem to be some inconsitent behaviour..

      this.setState({ open: true });
      // hack to set copy height
      //console.log('copy.offsetHeight',copy.offsetHeight);
      //copy.style.height = copy.offsetHeight + 'px';
      //featureImage.setAttribute('style','')

      //this.onResize();

      //console.log('thisPageYpos',thisPageYpos, thisContainerPostion.y ,window.pageYOffset);
      //open_tl.set(window,{scrollTo:{y:thisPageYpos}})

      //console.log('thisPageYpos',thisPageYpos, thisContainerPostion.y ,window.pageYOffset);
    });

    if (window.innerWidth > 769) {
      open_tl.from(featureImage, 3, { alpha: 0 }, "+=.5");
    }
    open_tl.add(() => {
      //this.scrollToThis()
    });
    open_tl.from(logo, 1, { alpha: 0 }, "-=1.5");
    open_tl.from(line, 0.5, { scaleX: 0 }, "-=1");
    open_tl.from(postal, 0.5, { alpha: 0 }, "-=.2");
    open_tl.from(telephone, 0.5, { alpha: 0 }, "-=0");
    open_tl.from(copy, 0.5, { alpha: 0 }, "-=0");
    open_tl.add(() => {
      //this.scrollToThis()
      document
        .querySelector("#transitonHolder")
        .classList.remove("no-transitions");
    });
    if (window.innerWidth < 769) {
      open_tl.from(featureImage, 0.5, { alpha: 0 }, "+=0");
    }
    open_tl.add(() => {
      this.setState({ showScrollArrow: true });
      clearInterval(this.state.scrollToInterval);
      // Calculate position again
      // set the position again.. just in case there seem to be some inconsitent behaviour..
      //this.scrollToThis()
    });

    //open_tl.from(peopleList,.5,{alpha:0});

    open_tl.add(() => {
      document.querySelector("body").classList.remove("force-hide-header");
      document
        .querySelector("body")
        .classList.remove("disable-pointer-events-and-scroll");
    });

    this.setState({ open_tl });

    // Fade in the content rows

    //console.log("content rows",thisContainer.querySelectorAll('.content-row'))
    /*
      let contentRows = thisContainer.querySelectorAll('.content-row')
      console.log('contentRows',contentRows,typeof(contentRows));

      for(let i=0;i<contentRows.length;i++){
        open_tl.from(contentRows[i],.5,{alpha:0});
      }; */

    //open_tl.to(window, 1, {scrollTo:'#workItemContainer',ease:Power2.easeInOut},'+=.5')
  }

  scrollToThis() {
    if (this.refs.container) {
      let thisContainerPostion = this.refs.container.getBoundingClientRect();
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let thisPageYpos = thisContainerPostion.top + scrollTop;

      //console.log('scrollToThis',thisPageYpos);
      //console.trace()
      window.scrollTo(0, thisPageYpos);
    }

    //debugger
  }

  componentWillUnmount() {
    this.state.open_tl.kill();
  }
  componentDidMount() {
    if (window.clickedOfficeThumb) {
      //console.log("window.clickedThumb ",window.clickedThumb.getBoundingClientRect());
      this.animateOpening(window.clickedOfficeThumb);

      // clear clickedThumb
      delete window.clickedOfficeThumb;

      //this.setState({open:true});
    } else {
      //this.setState({open:true})
      this.animateOpening();
      // delay 500 to make the previous page fade out first
      //setTimeout(this.scrollToThis,505);
    }

    //
  }

  render() {
    let slug = this.props.path.replace("/offices/", "").replace("/");

    let officeItem = this.props.officesData.data.filter((item) => {
      return item.slug === slug;
    })[0];

    // check for redirect

    if (officeItem.acf.redirect_page) {
      window.location.replace(officeItem.acf.redirect_url);
    }

    //console.log("officeItem",officeItem);

    let openClass = this.state.open ? " open" : " closed";
    let personCountClass = "person-count-" + officeItem.acf.people.length;

    let featureImageStyle = {
      backgroundImage: `url('${officeItem.acf.hero_image.url}')`,
    };

    let arrowStyle = {};

    if (window.innerWidth < 769) {
      arrowStyle = {
        //top:'auto',//(this.state.screenHeight - 110)+'px'
        //bottom:'120px'
      };

      arrowStyle = {
        top: this.props.screenSize.realScreenHeight - 150 + "px",
      };

      // landscape
      if (window.innerHeight < window.innerWidth) {
        arrowStyle = {
          top: this.props.screenSize.realScreenHeight - 110 + "px",
        };
      }
    }

    //console.log("officeItem", officeItem);

    return (
      <div
        className={"office-page scroll-anchor " + openClass}
        id="officePage"
        ref="container"
        pageslug={"/offices/" + officeItem.slug}
        onClick={this.getPosition}
      >
        <div className="background">
          <div className="description">
            <div className="inner">
              <div className="logo">
                {officeItem.acf.office_logo ? (
                  <img src={officeItem.acf.office_logo.url} alt="" />
                ) : (
                  "no logo uploaded"
                )}
                {/* <div className="city" dangerouslySetInnerHTML={{__html:officeItem.title.rendered}}></div> */}
              </div>
              <div className="line" />
              <div className="address-container">
                {officeItem.acf.office.google_maps_link ? (
                  <a
                    href={officeItem.acf.office.google_maps_link}
                    target="_blank"
                  >
                    <div
                      className="postal"
                      dangerouslySetInnerHTML={{
                        __html: officeItem.acf.office.postal_address,
                      }}
                    ></div>
                  </a>
                ) : (
                  <div
                    className="postal"
                    dangerouslySetInnerHTML={{
                      __html: officeItem.acf.office.postal_address,
                    }}
                  ></div>
                )}
                <div
                  className="telephone"
                  dangerouslySetInnerHTML={{
                    __html: officeItem.acf.office.telephone,
                  }}
                ></div>
              </div>

              <div className="copy">
                <div
                  className=""
                  dangerouslySetInnerHTML={{
                    __html: officeItem.acf.office.office_website_text,
                  }}
                />
                {officeItem.acf.office.office_website_url && (
                  <a
                    href={officeItem.acf.office.office_website_url}
                    target="_blank"
                    className="office-website-link"
                  >
                    <div
                      className=""
                      dangerouslySetInnerHTML={{
                        __html:
                          officeItem.acf.office.office_website_text_second_line,
                      }}
                    />
                  </a>
                )}
              </div>
            </div>

            {this.state.showScrollArrow ? (
              <ScrollArrow className="mobile-arrow" style={arrowStyle} />
            ) : null}
          </div>

          {/*(this.state.showScrollArrow && window.innerWidth > 768)?
                          <ScrollArrow />
                        : null*/}

          <div
            className={
              "feature-image " +
              (window.innerWidth < 769 ? "scroll-anchor" : "")
            }
          >
            <div className="photo clear" style={featureImageStyle}></div>
          </div>
        </div>

        <div className={"people-list scroll-anchor " + personCountClass}>
          {officeItem.acf.people.length
            ? officeItem.acf.people.map((item, index) => {
                return (
                  <Person
                    key={"p" + index}
                    {...item}
                    optionsData={this.props.optionsData}
                  />
                );
              })
            : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const officesData = state.KastnerStore.officesData;
  const optionsData = state.KastnerStore.optionsData;
  const screenSize = state.ScreenSize.screensize;

  return {
    officesData,
    optionsData,
    screenSize,
  };
};

export default connect(mapStateToProps)(OfficePage);



// WEBPACK FOOTER //
// ./src/modules/offices/OfficePage.js